module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.rows), function(row) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.id))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.description),
        expression: "row.description"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (row.description)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          row.description = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.quantity),
        expression: "row.quantity"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (row.quantity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          row.quantity = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.unit),
        expression: "row.unit"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          row.unit = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "1"
      }
    }, [_vm._v("Urakka")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "2"
      }
    }, [_vm._v("mm")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "3"
      }
    }, [_vm._v("m")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "3"
      }
    }, [_vm._v("m²")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "4"
      }
    }, [_vm._v("m³")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "5"
      }
    }, [_vm._v("t")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "6"
      }
    }, [_vm._v("kpl")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "7"
      }
    }, [_vm._v("h")])])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.deadline),
        expression: "row.deadline"
      }],
      attrs: {
        "type": "date"
      },
      domProps: {
        "value": (row.deadline)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          row.deadline = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('td', [_c('a', {
      on: {
        "click": function($event) {
          _vm.removeRow(row)
        }
      }
    }, [_vm._v("Poista rivi")])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "text-center bottom-margin-10"
  }, [_c('a', {
    staticClass: "btn btn-lg bottom-margin-10 btn-cal-poly-pomona-green",
    on: {
      "click": _vm.addRow
    }
  }, [_c('span', {
    staticClass: "ion ion-plus icon-spacer"
  }), _vm._v("Lisää rivi")]), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_c('strong', [_vm._v("Rivinumero")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Tekninen kuvaus")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Määrä")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Yksikkö")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Toimituspäivä")])]), _vm._v(" "), _c('td')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-lg bottom-margin-10 btn-cal-poly-pomona-green object-hidden",
    attrs: {
      "href": "#",
      "data-toggle-visibility": "hidden-row-job"
    }
  }, [_c('span', {
    staticClass: "ion ion-plus icon-spacer"
  }), _vm._v("Lisää urakka")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-80154e1a"}!./src/app/components/cost-row-component/cost-row-component.html
// module id = 495
// module chunks = 1